import { useTranslation } from 'react-i18next';

import { useNavigator } from '@/shared/navigation/react/useNavigator';
import { EntityEditLink } from '../../components/EntityEditLink';
import { serieDetailAgenda } from '../detail/serieDetailAgenda';

interface SerieLinkProps {
  /** Povinné parametry detailu seriálu. */
  productId: string;
  serieId: string;
  /** Zobrazený text seriálu (např. jeho název). */
  children: React.ReactNode;
}

/** Text seriálu s editačním tlačítkem, které otevře detail seriálu. */
export function SerieLink({ productId, serieId, children }: SerieLinkProps) {
  const { t } = useTranslation('venua-planner');
  const navigator = useNavigator();
  return (
    <EntityEditLink
      editLabel={t('actions.editSerie')}
      onEdit={() => void navigator.openModal(serieDetailAgenda, { productId, serieId })}
    >
      {children}
    </EntityEditLink>
  );
}
